import styled from 'styled-components';

export const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-weight: 700;
  color: ${({ fontColor }) => fontColor};
  font-size: ${({ fontSize }) => `${fontSize}px`};
  line-height: ${({ fontSize }) => `${fontSize * 1.5}px`};
  padding: ${({ pd }) => (pd ? `${pd}px` : '0')};
  margin-top: ${({ hasMargin }) => (hasMargin ? '16px' : 0)};
`;
